module.exports = __webpack_public_path__ + "static/media/img62.ef248ad2.jpg";